export const Badge = ({ tone = "blue", children, testid }) => {
  const tones = {
    blue: "border-esaia-blue/30 bg-esaia-blue/5 text-esaia-blue",
    green: "border-emerald-600/30 bg-emerald-50 text-emerald-700",
    red: "border-red-600/30 bg-red-50 text-red-700",
    amber: "border-amber-600/30 bg-amber-50 text-amber-700",
    slate: "border-esaia-line bg-esaia-surface text-esaia-muted",
  };
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 border px-2.5 py-1 font-mono text-[10px] uppercase tracking-[0.15em] ${tones[tone]}`}
    >
      {children}
    </span>
  );
};

export const statusTone = (s) =>
  ({ ACTIVE: "blue", COMPLETED: "green", PENDING: "amber", Requested: "amber", "Under Review": "blue", Active: "blue", Completed: "green", Declined: "red", EXPIRED: "red" }[s] || "slate");

export const Card = ({ title, action, children, testid, className = "" }) => (
  <div className={`border border-esaia-line bg-white ${className}`} data-testid={testid}>
    {title && (
      <div className="flex items-center justify-between border-b border-esaia-line px-6 py-4">
        <h2 className="text-sm font-semibold text-esaia-ink">{title}</h2>
        {action}
      </div>
    )}
    <div className="p-6">{children}</div>
  </div>
);

export const EmptyState = ({ message }) => (
  <div className="border border-dashed border-esaia-line bg-white px-6 py-12 text-center" data-testid="empty-state">
    <p className="text-sm text-esaia-subtle">{message}</p>
  </div>
);

export const fmtDate = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("en-GB", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return iso;
  }
};

export const fmtDateTime = (iso) => {
  if (!iso) return "—";
  try {
    const d = new Date(iso);
    return `${d.toLocaleDateString("en-GB")} ${d.toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}`;
  } catch {
    return iso;
  }
};

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const fileUrl = (kind, id, inline = false) => `${BASE}/files/${kind}/${id}/download${inline ? "?inline=1" : ""}`;
